const authRo = {
    "sign_in": "Conectare",
    "email": "Adresa de e-mail",
    "password": "Parolă",
    "sign_in_button": "Conectare",
    "invalid_credentials": "Acreditări nevalide",
    "password_min_length": "Parola trebuie să aibă cel puțin 8 caractere",
    "passwords_do_not_match": "Parolele nu se potrivesc",
    "invalid_token": "Jeton nevalid",
    "password_set": "Parolă setată",
    "confirm_password": "Confirmați parola",
    "confirm_title": "Confirmare înregistrare administrator Quickpick",
    "confirm_text": "Pentru a vă configura contul, trebuie doar să furnizați o parolă securizată",
    "set_password": "Setați parola",
    "account_activated": "Cont activat",
    "account_activated_text": "Acum vă puteți conecta la contul dvs. de utilizator cu adresa de e-mail și parola furnizate.",
    "continue_to_login": "Continuă să te autentifici",
    "forgotten_password": "Parolă uitată",
    "unable_to_reset_password": "Eroare internă, imposibil de resetat parola.",
    "reset_password_title": "Resetare parolă",
    "reset_password_text": "Vă rugăm să introduceți adresa de e-mail utilizată pentru contul dvs. Vă vom trimite linkul pentru resetarea parolei la adresa de e-mail.",
    "send_reset_mail": "Trimite link de resetare a parolei",
    "send_reset_mail_success": "Un e-mail cu instrucțiuni suplimentare a fost trimis la adresa furnizată.",
    "invalid_email": "Adresă de e-mail nevalidă",
    "reset_sent": "E-mail trimis",
    "change_password_title": "Schimbaţi parola",
    "change_password_success": "Parola a fost schimbată cu succes",
    "roles": {
        "OWNER": "Administrator",
        "MENU_EDITOR": "Editarea meniului",
        "STAFF_MANAGER": "Managementul personalului"
    },
    "name": "Nume",
    "permissions": "Permisiuni",
    "create_user_permissions": "Creați permisiuni de utilizator",
    "add_restaurant": "Adăugați restaurant",
    "user_saved": "Utilizatorul a fost salvat",
    "has_admin_permissions": "Permisiuni de administrator",
    "login_with_google": "Conectați-vă cu Google",
    "missing_perrmissions": "Nu aveți permisiunile necesare pentru a accesa această pagină",
    "qp_signup_title": "Înregistrare QuickPick",
    "qp_signup_text": "Completați câmpurile de mai jos pentru a crea un cont de utilizator!",
    "user_information": "Informații despre utilizator",
    "restaurant_information": "Informații despre restaurant",
    "restaurant_shortname": "Identificator restaurant",
    "restaurant_name": "Numele restaurantului",
    "create_profile": "Crea",
    "restaurant_name_short": "Numele restaurantului trebuie să aibă cel puțin 3 caractere",
    "identifier_example": "Exemplu de identificator",
    "invalid_shortname": "Identificatorul restaurantului trebuie să aibă cel puțin 3 caractere",
    "restaurant_shortname_already_in_use": "Identificatorul restaurantului este deja utilizat",
    "name_missing": "Numele lipsește",
    "signup_failed": "Înregistrarea a eșuat. Vă rugăm să încercați din nou mai târziu.",
    "no_restaurant_title": "Niciun restaurant selectat pentru contul dvs.",
    "no_restaurant_text": "Dacă tocmai ți-ai creat contul, ar trebui să-ți înregistrezi și restaurantul!",
    "no_restaurant_alt": "Dacă ar fi trebuit să primiți acces la un restaurant, vă rugăm să contactați administratorul restaurantului.",
    "no_user_created_yet": "Nu ai încă un cont?",
    "signup_success": "Înregistrare reușită",
    "grant_admin_title": "Acordați permisiuni de administrator",
    "grant_admin_confirmation": "Utilizatorul cu permisiuni de administrator poate gestiona setările restaurantului, poate adăuga și elimina utilizatori, poate gestiona abonamente, plăți și facturi. Editarea meniului nu necesită permisiuni de administrator.",
    "selected_user": "Utilizator selectat",
    "delete_user_title": "Eliminați utilizatorul",
    "delete_user_confirmation": "Utilizatorul selectat va fi eliminat din restaurant și nu va mai avea acces la meniul acestuia. Această acțiune nu poate fi anulată.",
    "admin": "Administrator",
    "activate_account": "Activează contul",
    "account_pending_activation": "Contul dumneavoastră de utilizator este în așteptarea activării.",
    "check_your_activate_email": "Vă rugăm să verificați căsuța poștală de e-mail și să faceți clic pe linkul de activare",
    "refresh_page": "Reîmprospătați pagina",
    "did_not_receive_activation_email": "Nu am primit e-mailul de activare",
    "activate_tip": "Dacă nu găsiți e-mailul de activare, verificați și folderul de spam. Dacă nu este acolo, faceți clic pe butonul de mai jos pentru a-l retrimite.",
    "resend_email": "Retrimite",
    "email_resent": "E-mailul de activare a fost retrimis cu succes. Vă rugăm să verificați căsuța poștală de e-mail.",
    "accept_terms_and_conditions": "Am citit și accept <a>Termenii și condițiile și Politica de confidențialitate</a>",
    "complete_registration": "Înregistrare completă",
    "auth_in_progress": "Autentificare în curs...",
    "account_successfully_activated": "Contul dumneavoastră QuickPick a fost activat cu succes",
    "continue_to_home_page": "Continuați la pagina principală",
    "invalid_activation": "A apărut o eroare la activarea contului. Vă rugăm să încercați din nou mai târziu sau să contactați serviciul nostru de asistență pentru clienți.",
    "activation_mail_sent": "Am început crearea contului dumneavoastră. Vă rugăm să verificați căsuța poștală de e-mail și să finalizați înregistrarea făcând clic pe linkul din e-mail."
};

export default authRo;
